import Axios from 'axios';
import { getCookie } from 'UtilityComponents/Util';
import { APPLICATION_CONSTANTS, FQDNS } from 'AppConstants';

export const getccbAxiosConfig = (passHeaders, customHeaders, withCredentials = true) => {
	let ccbConfig = {
		baseURL: typeof window == 'undefined' ? FQDNS.SERVER_CCB_URL : FQDNS.CCB_URL,
		timeout: 30000,
		withCredentials: withCredentials
	};

	if (passHeaders) {
		ccbConfig['headers'] = {
			'Content-Type': 'application/json',
			'Accept': 'application/json'
		};
	}

	const auth = getCookie('mmt-auth');
	if (!withCredentials && auth) {
		ccbConfig['headers']['mmt-auth'] = auth;
	}

	if (customHeaders && passHeaders) {
		ccbConfig['headers'] = { ...ccbConfig['headers'], ...customHeaders };
	}
	return Axios.create(ccbConfig);
};

export const ccbAxiosApiCaller = getccbAxiosConfig(true, {
	[APPLICATION_CONSTANTS.DEVICE_TYPE_KEY]: APPLICATION_CONSTANTS.DEVICE_TYPE
}, false);
